/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Camera_Dialog_Add_TitleInputs */

const vi_grower_area_camera_dialog_add_title = /** @type {(inputs: Grower_Area_Camera_Dialog_Add_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm camera`)
};

/**

* @param {Grower_Area_Camera_Dialog_Add_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_camera_dialog_add_title = /** @type {((inputs?: Grower_Area_Camera_Dialog_Add_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Camera_Dialog_Add_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_camera_dialog_add_title(inputs)
});